/**
 *  CampaignDetail script file
**/

import campaignsService from '@/api/campaignsService'
import layerService from '@/api/layerService'
import { IconLayer } from '@deck.gl/layers'
import { mapMutations } from 'vuex'
import { MODULE_NAME, MUTATIONS } from '@/store/map/constants'
import { multiPoint, bbox as getBbox } from '@turf/turf'

const shopIconUrl = require('@/assets/icons/map/icon-store.svg')

export default {
  name: 'CampaignDetail',
  mixins: [],
  components: {
    MapComponent: () => import('@/components/map-component/MapComponent.vue'),
    CampaignDetailHeader: () => import('@/components/campaign-detail-header/CampaignDetailHeader.vue'),
    CampaignDetailSidebar: () => import('@/components/campaign-detail-sidebar/CampaignDetailSidebar.vue')
  },
  props: {},
  data () {
    return {
      sidebarExpanded: true,
      mapLoaded: false,
      campaign: null,
      shopLayerId: 'campaign-details-shops'
    }
  },
  computed: {
    campaignid () {
      return this.$route.params.campaignid
    }
  },
  async mounted () {
    this.campaign = await campaignsService.getCampaign({ id: this.campaignid })
  },
  beforeDestroy () {
    this[MUTATIONS.RESET_VIEWSTATE]()
    layerService.removeLayer(this.shopLayerId)
  },
  methods: {
    ...mapMutations(MODULE_NAME, [ MUTATIONS.RESET_VIEWSTATE, MUTATIONS.CENTER_BBOX ]),
    async onMapLoaded () {
      this.drawShops()
      this.centerMap()
      this.mapLoaded = true
    },
    drawShops () {
      layerService.addLayer({
        id: this.shopLayerId,
        layerType: IconLayer,
        pickable: true,
        data: this.campaign.shops,
        getPosition: d => [d.lng, d.lat],
        getSize: 48,
        getIcon: () => ({
          width: 40,
          height: 40,
          url: shopIconUrl
        }),
        getTooltip ({ object }) {
          const text = `${object.name || object.label}`
          const style = {
            'background': 'var(--colorNegative)',
            color: 'var(--colorHigh)'
          }
          return { text, style, className: 'map-popup-white' }
        }
      })
    },
    resize () {
      this.sidebarExpanded = !this.sidebarExpanded
    },
    centerMap () {
      const data = this.campaign.shops.map(p => [p.lng, p.lat])
      const geojson = multiPoint(data)
      const [minX, minY, maxX, maxY] = getBbox(geojson)
      this[MUTATIONS.CENTER_BBOX]({ bbox: [[minX, minY], [maxX, maxY]], maxZoom: 13 })
    }
  }
}
